/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Divider,
  IconButton,
  Grid,
  Drawer as MuiDrawer,
  Link,
  List,
  ListItem,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import { Typography } from "@invosys/invosys-ui";
import { Adjust, ChevronLeft, ChevronRight } from "@material-ui/icons";
import { iconMap } from "./iconMap";
import Avatar from "./Avatar";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: 57,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  listItemText: {
    marginLeft: theme.spacing(2),
  },
  link: {
    cursor: "pointer",
  },
  logo: {
    maxWidth: "200px",
    maxHeight: "50px",
    margin: "0 auto",
    transition: "opacity 0.5s ease-in-out",
    opacity: 1,
  },
  logoHidden: {
    opacity: 0,
  },
}));

const Vertical = (props) => {
  const classes = useStyles();
  const { links } = props;
  const [open, setOpen] = useState(false);
  const direction = "ltr"; // can be rtl

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <MuiDrawer
          variant="permanent"
          className={open ? classes.drawerOpen : classes.drawerClose}
          classes={{
            paper: open ? classes.drawerOpen : classes.drawerClose,
          }}
          PaperProps={{ elevation: 23 }}
        >
          <div className={classes.toolbar}>
            <img
              src={props.imagePath}
              alt="CompanyLogo"
              className={`${classes.logo} ${!open ? classes.logoHidden : ""}`}
            />
            <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
              {direction === "ltr" ? (
                open ? (
                  <ChevronLeft color="primary" />
                ) : (
                  <ChevronRight color="primary" />
                )
              ) : open ? (
                <ChevronRight color="primary" />
              ) : (
                <ChevronLeft color="primary" />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>
            {links
              .sort((a, b) => a.index - b.index)
              .map((link, idx) => {
                const LinkIcon = iconMap[link.title] || Adjust;
                return (
                  <ListItem key={`${link.index}_${idx}`}>
                    <Link
                      href={link.link}
                      className={`${classes.link}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                      }}
                    >
                      <Tooltip
                        title={!open ? link.title : ""}
                        placement="right"
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <LinkIcon />
                          {open && (
                            <Typography
                              variant="body1"
                              className={classes.listItemText}
                              color="textPrimary"
                            >
                              {link.title}
                            </Typography>
                          )}
                        </div>
                      </Tooltip>
                    </Link>
                  </ListItem>
                );
              })}
          </List>
          <Divider />
          <div style={{ width: "fit-content", margin: "8px" }}>
            <Avatar namePlacement={open ? "right" : "menu"} />
          </div>
        </MuiDrawer>
      </Grid>
    </React.Fragment>
  );
};

Vertical.propTypes = {
  jwt: PropTypes.string,
  links: PropTypes.array.isRequired,
  imagePath: PropTypes.string.isRequired,
};

export default Vertical;
